import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IInvoiceCycle } from '../IInvoiceCycle';


export const getInvoiceCycle = createAction('[InvoiceCycle/API] Get Invoice Cycle');

export const loadInvoiceCycles = createAction(
  '[InvoiceCycle/API] Load InvoiceCycles',
  props<{ invoiceCycles: IInvoiceCycle[] }>()
);

export const addInvoiceCycle = createAction(
  '[InvoiceCycle/API] Add InvoiceCycle',
  props<{ invoiceCycle: IInvoiceCycle }>()
);

export const upsertInvoiceCycle = createAction(
  '[InvoiceCycle/API] Upsert InvoiceCycle',
  props<{ invoiceCycle: IInvoiceCycle }>()
);

export const addInvoiceCycles = createAction(
  '[InvoiceCycle/API] Add InvoiceCycles',
  props<{ invoiceCycles: IInvoiceCycle[] }>()
);

export const upsertInvoiceCycles = createAction(
  '[InvoiceCycle/API] Upsert InvoiceCycles',
  props<{ invoiceCycles: IInvoiceCycle[] }>()
);

export const updateInvoiceCycle = createAction(
  '[InvoiceCycle/API] Update InvoiceCycle',
  props<{ invoiceCycle: Update<IInvoiceCycle> }>()
);

export const updateInvoiceCycles = createAction(
  '[InvoiceCycle/API] Update InvoiceCycles',
  props<{ invoiceCycles: Update<IInvoiceCycle>[] }>()
);

export const deleteInvoiceCycle = createAction(
  '[InvoiceCycle/API] Delete InvoiceCycle',
  props<{ id: string }>()
);

export const deleteInvoiceCycles = createAction(
  '[InvoiceCycle/API] Delete InvoiceCycles',
  props<{ ids: string[] }>()
);

export const clearInvoiceCycles = createAction(
  '[InvoiceCycle/API] Clear InvoiceCycles'
);
